var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReceiveSolid = function SvgReceiveSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 2a1 1 0 0 0-2 0v6.002c-2.33.01-3.537.106-3.92.912a1.59 1.59 0 0 0-.022.05c-.403.928.582 2.053 2.551 4.304 1.105 1.262 1.657 1.893 2.37 1.902h.041c.714-.009 1.266-.64 2.37-1.902 1.97-2.25 2.954-3.376 2.552-4.304a1.493 1.493 0 0 0-.023-.05c-.382-.806-1.59-.901-3.919-.912V2Z",
    clipRule: "evenodd"
  })));
};
export default SvgReceiveSolid;